module.exports = __webpack_public_path__ + "img/silver.f4e63f14.png";